import { useCallback, useState } from "react";
import { useGlobalContext } from "../Context/GlobalContext";

export const useCatalogueStatus = () => {
  const { api } = useGlobalContext();

  const [catalogueStatusLoading, setCatalogueStatusLoading] = useState(false);
  const [catalogueStatusError, setCatalogueStatusError] = useState("");

  const getCatalogueStatus = useCallback(
    async ({ userid }) => {
      const cleanUserId = String(userid || "").trim();

      if (!cleanUserId) {
        const message = "Restaurant userid is missing.";

        setCatalogueStatusError(message);

        return {
          success: false,
          catalogueStatus: "",
          isOpen: false,
          message,
        };
      }

      try {
        setCatalogueStatusLoading(true);
        setCatalogueStatusError("");

        const payload = {
          userid: cleanUserId,
        };

        console.log("getCatalogueStatus PAYLOAD:", payload);

        const response = await api.post(
          "/Whatsapp/getCatalogueStatus",
          payload,
        );

        const responseData = response?.data;

        console.log("getCatalogueStatus RESPONSE:", responseData);

        if (String(responseData?.responseCode) !== "00") {
          const message =
            responseData?.responseMessage ||
            "Unable to fetch catalogue status.";

          setCatalogueStatusError(message);

          return {
            success: false,
            catalogueStatus: "",
            isOpen: false,
            message,
          };
        }

        const catalogueStatus = String(
          responseData?.response?.catalogueStatus || "",
        )
          .trim()
          .toLowerCase();

        return {
          success: true,

          catalogueStatus,

          // Only "show" means restaurant catalogue is available.
          isOpen: catalogueStatus === "show",

          message: responseData?.responseMessage || "",
        };
      } catch (error) {
        console.error(
          "getCatalogueStatus API error:",
          error?.response?.data || error,
        );

        const message =
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          error?.message ||
          "Unable to fetch catalogue status.";

        setCatalogueStatusError(message);

        return {
          success: false,
          catalogueStatus: "",
          isOpen: false,
          message,
        };
      } finally {
        setCatalogueStatusLoading(false);
      }
    },
    [api],
  );

  const resetCatalogueStatus = useCallback(() => {
    setCatalogueStatusError("");
    setCatalogueStatusLoading(false);
  }, []);

  return {
    getCatalogueStatus,
    catalogueStatusLoading,
    catalogueStatusError,
    resetCatalogueStatus,
  };
};
